/**
 * Authoritative route SEO + indexability manifest.
 *
 * Only the home route is public, indexable and eligible for the sitemap.
 * The catch-all route ("*") renders the 404 page which must stay non-indexable.
 */
export interface RouteSeo {
  path: string;
  /** Whether the page is public and may be indexed by search engines. */
  indexable: boolean;
  /** Whether the page may be listed in the sitemap. */
  sitemapInclude: boolean;
  title: string;
  description: string;
  keywords?: string;
  ogType?: string;
}

export const HOME_SEO: RouteSeo = {
  path: '/',
  indexable: true,
  sitemapInclude: true,
  title: '武汉俊鑫岚科技有限公司 - 工业物资与建材一站式供应',
  description:
    '武汉俊鑫岚科技有限公司专注建筑建材、机械电气、金属材料、电子配件、五金耗材等物资供应，为企业与工程客户提供一站式采购、配送与商务代理服务。',
  keywords:
    '武汉俊鑫岚科技,建筑建材供应,工业物资采购,机械电气设备,金属材料销售,五金耗材供应,商务代理代办',
  ogType: 'website',
};

/** Fallback SEO for non-indexable / unknown routes (e.g. 404). */
export const NOT_FOUND_SEO: RouteSeo = {
  path: '*',
  indexable: false,
  sitemapInclude: false,
  title: '页面未找到 - 武汉俊鑫岚科技有限公司',
  description: '您访问的页面不存在或已被移动。',
};

export const routeSeoList: RouteSeo[] = [HOME_SEO];

/**
 * Resolve the SEO data for a given pathname. Unknown routes fall back to the
 * non-indexable 404 metadata so nothing gets indexed by accident.
 */
export function getRouteSeo(pathname: string): RouteSeo {
  const normalized = pathname !== '/' ? pathname.replace(/\/+$/, '') || '/' : '/';
  const match = routeSeoList.find((item) => item.path === normalized);
  return match ?? NOT_FOUND_SEO;
}